export default {
  namespaced: true,
  state: {
    confirm: {},
    isConfirmOpen: false,
    loadingMessage: null,
    isLoadingOpen: false
  },
  mutations: {
    OPEN_CONFIRM (state, info) {
      state.confirm = info
      state.isConfirmOpen = true
    },
    CLOSE_CONFIRM (state) {
      state.confirm = {}
      state.isConfirmOpen = false
    },
    SHOW_LOADING (state, message) {
      state.loadingMessage = message
      state.isLoadingOpen = true
    },
    HIDE_LOADING (state) {
      state.isLoadingOpen = false
    }
  },
  actions: {
    openConfirm ({ commit }, {
      message = '',
      title = 'Are You Sure?',
      acceptClass = 'btn-outline-primary',
      acceptText = 'Yes',
      actionClass = 'btn-outline-primary',
      actionFunc = null,
      actionText = 'Save',
      cancelClass = 'btn-outline-secondary',
      cancelText = 'Cancel',
      confirmLevel = 0,
      confirmTerm = '',
      hideCancel = false
    }) {
      return new Promise(resolve => {
        commit('OPEN_CONFIRM', {
          message,
          title,
          acceptClass,
          acceptText,
          actionClass,
          actionFunc,
          actionText,
          cancelClass,
          cancelText,
          confirmLevel,
          confirmTerm,
          hideCancel,
          resolve
        })
      })
    },
    showLoading ({ commit }, message) {
      commit('SHOW_LOADING', message)
    },
    hideLoading ({ commit }) {
      commit('HIDE_LOADING')
    }
  }
}
